import { Globe, Database, Code, Wrench, Brain, GraduationCap } from "lucide-react";

export const projects = [
  {
    id: 1,
    title: "0-shell",
    date: "2025-06",
    description:
      "A lightweight, standalone shell inspired by BusyBox, built for embedded Linux environments using Rust. Implements core shell commands from scratch without relying on external programs.",
    image: "/0shell.png",
    tags: ["Rust", "Shell", "BusyBox", "Unix"],
    category: "lowlevel",
    github: "https://github.com/aminehabchi/0-shell",
    live: null,
  },
  {
    id: 2,
    title: "Local-Server",
    date: "2025-11",
    description:
      "An HTTP/1.1-compliant web server in Java built from scratch using non-blocking I/O. Demonstrates understanding of network protocols, socket programming, and event-driven architecture.",
    image: null,
    tags: ["Java", "HTTP", "Non-blocking I/O", "Virtual Hosts"],
    category: "lowlevel",
    github: "https://github.com/aminehabchi/Local-Server",
    live: null,
  },
  {
    id: 3,
    title: "JRaffic",
    date: "2025-08",
    description:
      "Simulates a four-way traffic intersection with realistic traffic light controls, car movement, and collision detection. Manages traffic flow using priority-based algorithms.",
    image: "/Jraffic.gif",
    tags: ["Java", "JavaFX", "Simulation"],
    category: "backend",
    github: "https://github.com/aminehabchi/jraffic",
    live: null,
  },
  {
    id: 4,
    title: "NeuroFlow",
    date: "2025-07",
    description:
      "An ADHD-friendly Chrome extension that attaches todos to each website you visit. Contextual task management built for clarity and simplicity.",
    image: "/neuro.png",
    tags: ["JavaScript", "CSS", "HTML", "Extension"],
    category: "tools",
    github: "https://github.com/aminehabchi/NeuroFlow",
    live: null,
  },
  {
    id: 5,
    title: "Forum",
    date: "2024-10",
    description:
      "A web forum application using Go, SQLite, and Docker. Users can communicate through posts and comments, associate categories, like/dislike content, and filter posts.",
    image: "/diagram.png",
    tags: ["Go", "SQLite", "Docker", "HTML/JS"],
    category: "backend",
    github: "https://github.com/aminehabchi/forum.git",
    live: null,
  },
  {
    id: 6,
    title: "Social Network",
    date: "2025-07",
    description:
      "A full-stack Facebook-like social networking platform with a Next.js frontend and Go backend. Features authentication, real-time communication via WebSockets, and Docker containerization.",
    image: "/mokeup.png",
    tags: ["Next.js", "Go", "SQLite", "WebSocket", "Docker"],
    category: "fullstack",
    github: "https://github.com/aminehabchi/social-network",
    live: null,
  },
  {
    id: 7,
    title: "CollaboBoard",
    date: "2025-05",
    description:
      "A collaborative, real-time whiteboard application in Rust. Multiple users can draw together on a shared canvas over the network with synchronization between clients.",
    image: "/screenshot.gif",
    tags: ["Rust", "Tokio", "TCP", "Serialization"],
    category: "lowlevel",
    github: "https://github.com/aminehabchi/CollaboBoard",
    live: null,
  },
  {
    id: 8,
    title: "Bomberman DOM",
    date: "2025-04",
    description:
      "A multiplayer Bomberman game in vanilla JavaScript and WebSockets, without canvas or WebGL. 2–4 players battle until one remains standing.",
    image: "/game.png",
    tags: ["JavaScript", "Node.js", "Socket.io", "Custom Framework"],
    category: "fullstack",
    github: "https://github.com/aminehabchi/bomberman-dom",
    live: null,
  },
  {
    id: 11,
    title: "TCP Chat",
    date: "2024-09",
    description:
      "A TCP chat server built in both Rust and Go that creates a group chat environment. Users connect via netcat or any TCP client for real-time group messaging.",
    image: null,
    tags: ["TCP", "Rust", "Go", "Concurrency"],
    category: "lowlevel",
    github: "https://github.com/aminehabchi/TCP-CHAT",
    live: null,
  },
  {
    id: 12,
    title: "Mini Framework",
    date: "2025-03",
    description:
      "A lightweight front-end JavaScript framework from scratch with virtual DOM, component-based architecture, client-side routing, and state management.",
    image: null,
    tags: ["JavaScript", "Virtual DOM", "SPA", "OOP"],
    category: "frontend",
    github: "https://github.com/aminehabchi/mini-framework",
    live: null,
  },
  {
    id: 14,
    title: "FS",
    date: "2025-08",
    description:
      "A simple filesystem implementation in Rust. Demonstrates how filesystems work at a low level managing files, inodes, and blocks programmatically.",
    image: null,
    tags: ["Rust", "Unix", "Filesystem"],
    category: "lowlevel",
    github: "https://github.com/aminehabchi/FS",
    live: null,
  },
  {
    id: 15,
    title: "Market Place",
    date: "2026-02",
    description:
      "A distributed e-commerce ecosystem built with a microservices architecture. Features service discovery, an API gateway, async messaging via Kafka, and Redis caching across independently deployable Spring Boot services.",
    image: null,
    tags: ["Spring Boot", "Angular", "Kafka", "MongoDB", "Redis", "Docker", "Microservices"],
    category: "fullstack",
    github: "https://github.com/aminehabchi/market-place",
    live: null,
  },
  {
    id: 16,
    title: "Echo & Script",
    date: "2025-09",
    description:
      "A full-stack social blogging platform combining content creation with social features. Users create and share posts, interact through likes/comments, and communicate via real-time WebSocket chat.",
    image: "./echo_script.png",
    tags: ["Spring Boot", "Angular", "JWT", "WebSocket", "PostgreSQL", "Docker"],
    category: "fullstack",
    github: "https://github.com/aminehabchi/Echo_Script",
    live: null,
  },
  {
    id: 17,
    title: "Ideathon",
    date: "2025-10",
    description:
      "A platform where individuals and organizations launch short idea challenges to gather fresh perspectives, test assumptions, and spark innovation.",
    image: "./ideathon.png",
    tags: ["Go", "SQLite", "Next.js", "Sessions"],
    category: "fullstack",
    github: "https://github.com/aminehabchi/IdeaThon",
    live: "https://idea-thon.vercel.app/",
  },
  {
    id: 18,
    title: "SeniorifyUI",
    date: "2025-09",
    description:
      "An Advanced Style Prompt Builder that transforms junior front-end developers into UI experts using AI-assisted guidance.",
    image: "/seniorifyui.png",
    tags: ["React", "AI", "Hackathon"],
    category: "tools",
    github: "https://github.com/aminehabchi/SeniorifyUI",
    live: "https://seniorify-ui.vercel.app/",
  },
  {
    id: 19,
    title: "SmartNews",
    date: "2026-07",
    description:
      "A full-stack NLP pipeline that scrapes tech news, extracts named entities, classifies topics, and scores sentiment, then serves it through a FastAPI REST API and an Angular UI with search, filters, and a stats dashboard.",
    image: "/smartnews.png",
    tags: ["Python", "spaCy", "scikit-learn", "FastAPI", "Angular", "MongoDB", "Playwright", "Docker"],
    category: "ai",
    github: "https://github.com/aminehabchi/smart-news",
    live: null,
  },
  {
    id: 20,
    title: "Kwan Code",
    date: "2026-10",
    description:
      "A hosted platform that takes a software team through the whole life of a project: planning, coding with AI agents, reviewing, and delivering. Combines a FastAPI server with git hosting and a full audit trail, an Angular admin dashboard, and an Electron desktop editor where developers run team-defined Claude Code agents under clear roles and rules.",
    image: null,
    tags: ["Claude Code", "AI Agents", "FastAPI", "PostgreSQL", "Angular", "Electron", "Monaco", "Docker"],
    category: "ai",
    github: null,
    live: "https://kwan-code.com",
  },
  {
    id: 21,
    title: "Local RAG Service",
    date: "2026-04",
    description:
      "A fully local Retrieval-Augmented Generation system: upload PDF and TXT documents, index and embed them, then chat with your knowledge base. Supports semantic, keyword, and hybrid (RRF) search over pgvector, and switchable LLM backends (Ollama, OpenAI, Anthropic, Gemini).",
    image: null,
    tags: ["RAG", "Python", "FastAPI", "Ollama", "pgvector", "PostgreSQL", "Angular", "Docker"],
    category: "ai",
    github: "https://github.com/aminehabchi/Local-RAG-Service",
    live: null,
  },
  {
    id: 22,
    title: "Kaggle Titanic",
    date: "2026-02",
    description:
      "Predicting Titanic passenger survival for the Kaggle competition, with a best leaderboard score of 0.80861. A random forest with 0.84 cross-validated accuracy scored worse than the gender baseline; the best result came from a few well-supported rules instead of a stronger model.",
    image: null,
    tags: ["Python", "scikit-learn", "Pandas", "NumPy", "Jupyter", "Kaggle"],
    category: "ai",
    github: "https://github.com/aminehabchi/kaggle-titanic",
    live: null,
  },
  {
    id: 29,
    title: "Let's Play",
    date: "2025-12",
    description:
      "A secure RESTful CRUD API for managing users and products, with JWT authentication, role-based access control (admins manage everything, users only their own products), BCrypt password hashing, input validation, and global exception handling.",
    image: null,
    tags: ["Java", "Spring Boot", "Spring Security", "JWT", "MongoDB", "Docker"],
    category: "backend",
    github: "https://github.com/aminehabchi/lets-play",
    live: null,
  },
  {
    id: 30,
    title: "Angul-It",
    date: "2026-02",
    description:
      "An interactive multi-stage CAPTCHA web app: progressive challenges validated with Reactive Forms, progress saved across page refreshes, and route guards that stop users from skipping to the result page.",
    image: null,
    tags: ["Angular", "TypeScript", "Reactive Forms", "Angular Material"],
    category: "frontend",
    github: "https://github.com/aminehabchi/angul-it",
    live: null,
  },
  {
    id: 31,
    title: "Knowledge Transfer Agent",
    date: "2026-10",
    description:
      "Keeps project knowledge from walking out the door: a departing teammate writes a structured handover with AI-suggested follow-up questions, a manager reviews and approves it, and the incoming teammate gets an assistant that answers only from approved sources and cites them. Works with Claude, OpenAI, Gemini, or Ollama, in English and French.",
    image: null,
    tags: ["AI Agents", "Python", "FastAPI", "React", "TypeScript", "MongoDB", "Ollama", "Docker"],
    category: "ai",
    github: "https://github.com/aminehabchi/Knowledge-Transfer-Agent",
    live: null,
  },
  {
    id: 23,
    title: "Piscine Scripting",
    date: "2026-01",
    description:
      "Two weeks of shell scripting and automation: file management, permissions, text processing with awk/grep/cut, JSON with jq and curl, I/O redirection, cron scheduling, and Python basics.",
    image: null,
    tags: ["Bash", "Shell", "awk", "jq", "cron", "Python"],
    category: "piscine",
    github: "https://github.com/aminehabchi/piscine-scripting",
    live: null,
  },
  {
    id: 24,
    title: "Piscine AI",
    date: "2026-01",
    description:
      "Python for data and machine learning: NumPy, Pandas, visualization, data wrangling, time series, linear regression, classification, model selection, pipelines, neural networks with Keras, and NLP.",
    image: null,
    tags: ["Python", "NumPy", "Pandas", "scikit-learn", "Keras", "NLP"],
    category: "piscine",
    github: "https://github.com/aminehabchi/piscine-ai",
    live: null,
  },
  {
    id: 25,
    title: "Piscine Java",
    date: "2025-08",
    description:
      "Core Java and object-oriented programming: classes, encapsulation, inheritance, polymorphism, collections, exceptions, file I/O, the standard library, and design patterns.",
    image: null,
    tags: ["Java", "OOP", "Design Patterns", "Collections"],
    category: "piscine",
    github: "https://github.com/aminehabchi/piscine-java",
    live: null,
  },
  {
    id: 26,
    title: "Piscine Rust",
    date: "2025-05",
    description:
      "Rust from the basics to advanced concepts: ownership, borrowing and lifetimes, structs and enums, pattern matching, error handling, modules, collections and iterators, concurrency, and testing.",
    image: null,
    tags: ["Rust", "Ownership", "Concurrency", "Cargo"],
    category: "piscine",
    github: "https://github.com/aminehabchi/piscine-rust",
    live: null,
  },
  {
    id: 27,
    title: "Piscine JS",
    date: "2024-09",
    description:
      "One month of JavaScript: core language and ES6+ features, asynchronous code with promises and async/await, the DOM, debugging and testing, and algorithmic problem solving.",
    image: null,
    tags: ["JavaScript", "ES6+", "Async", "DOM"],
    category: "piscine",
    github: "https://github.com/aminehabchi/piscine-js",
    live: null,
  },
  {
    id: 28,
    title: "Piscine Go",
    date: "2024-01",
    description:
      "One month of Go: syntax and control flow, functions and recursion, slices and maps, structs and pointers, error handling, linked lists, binary trees, and algorithms.",
    image: null,
    tags: ["Go", "Algorithms", "Data Structures"],
    category: "piscine",
    github: "https://github.com/aminehabchi/piscine-go",
    live: null,
  },
];

export const filterCategories = [
  { key: "ai", icon: Brain },
  { key: "fullstack", icon: Code },
  { key: "frontend", icon: Globe },
  { key: "backend", icon: Database },
  { key: "lowlevel", icon: Wrench },
  { key: "tools", icon: Wrench },
  { key: "piscine", icon: GraduationCap },
];

// The year I started coding, for the "Years coding" stat.
export const codingSince = 2023;

// Skills are built from the projects' tags (see buildSkills below). The catalog
// gives each skill its group and color; `always` shows a skill no project tags.
export const skillGroups = [
  "Frontend",
  "Backend",
  "Systems",
  "Database",
  "APIs",
  "AI & ML",
  "Data Analytics",
  "DevOps",
  "Tools",
  "Other",
];

export const skillCatalog = {
  // Frontend
  "Next.js": { group: "Frontend", color: "#e2e8f0" },
  Angular: { group: "Frontend", color: "#ef4444" },
  React: { group: "Frontend", color: "#22d3ee" },
  JavaScript: { group: "Frontend", color: "#fbbf24" },
  TypeScript: { group: "Frontend", color: "#3b82f6", always: true },
  HTML5: { group: "Frontend", color: "#fb923c" },
  CSS: { group: "Frontend", color: "#60a5fa" },
  SCSS: { group: "Frontend", color: "#db2777", always: true },
  "Tailwind CSS": { group: "Frontend", color: "#22d3ee", always: true },
  "Angular Material": { group: "Frontend", color: "#ef4444" },
  "Reactive Forms": { group: "Frontend", color: "#ef4444" },
  Electron: { group: "Frontend", color: "#9feaf9" },
  JavaFX: { group: "Frontend", color: "#f97316" },
  // Backend
  "Node.js": { group: "Backend", color: "#4ade80" },
  Go: { group: "Backend", color: "#06b6d4" },
  Java: { group: "Backend", color: "#f97316" },
  Python: { group: "Backend", color: "#4dabf7" },
  "Spring Boot": { group: "Backend", color: "#6cb52d" },
  "Spring Security": { group: "Backend", color: "#6cb52d" },
  "Spring Gateway": { group: "Backend", color: "#6cb52d", always: true },
  "Spring Eureka": { group: "Backend", color: "#6cb52d", always: true },
  FastAPI: { group: "Backend", color: "#10b981" },
  "Apache Kafka": { group: "Backend", color: "#94a3b8" },
  Redis: { group: "Backend", color: "#ef4444" },
  Microservices: { group: "Backend", color: "#c084fc" },
  // Systems
  Rust: { group: "Systems", color: "#dea584" },
  C: { group: "Systems", color: "#94a3b8", always: true },
  Tokio: { group: "Systems", color: "#a78bfa" },
  TCP: { group: "Systems", color: "#6366f1" },
  Unix: { group: "Systems", color: "#fcd34d" },
  // Database
  PostgreSQL: { group: "Database", color: "#3b82f6" },
  MongoDB: { group: "Database", color: "#10b981" },
  SQLite: { group: "Database", color: "#22c55e" },
  pgvector: { group: "Database", color: "#60a5fa" },
  // APIs
  "RESTful APIs": { group: "APIs", color: "#c084fc", always: true },
  WebSockets: { group: "APIs", color: "#6366f1" },
  HTTP: { group: "APIs", color: "#a78bfa" },
  JWT: { group: "APIs", color: "#f472b6" },
  // AI & ML
  "Claude Code": { group: "AI & ML", color: "#f97316" },
  "AI Agents": { group: "AI & ML", color: "#a78bfa" },
  RAG: { group: "AI & ML", color: "#a78bfa" },
  Ollama: { group: "AI & ML", color: "#ef4444" },
  OCR: { group: "AI & ML", color: "#2dd4bf", always: true },
  NLP: { group: "AI & ML", color: "#f472b6" },
  spaCy: { group: "AI & ML", color: "#22d3ee" },
  "scikit-learn": { group: "AI & ML", color: "#fb923c" },
  Keras: { group: "AI & ML", color: "#ef4444" },
  // Data Analytics
  NumPy: { group: "Data Analytics", color: "#4dabf7" },
  Pandas: { group: "Data Analytics", color: "#a78bfa" },
  Jupyter: { group: "Data Analytics", color: "#fb923c" },
  "Data Wrangling": { group: "Data Analytics", color: "#94a3b8", always: true },
  "Data Visualization": { group: "Data Analytics", color: "#f472b6", always: true },
  // DevOps
  Docker: { group: "DevOps", color: "#0ea5e9" },
  "Shell Scripting": { group: "DevOps", color: "#4ade80" },
  Git: { group: "DevOps", color: "#f97316", always: true },
  GitHub: { group: "DevOps", color: "#e2e8f0", always: true },
  cron: { group: "DevOps", color: "#fcd34d" },
  // Tools
  Playwright: { group: "Tools", color: "#4ade80" },
  "VS Code": { group: "Tools", color: "#3b82f6", always: true },
  Postman: { group: "Tools", color: "#fb923c", always: true },
  Figma: { group: "Tools", color: "#a78bfa", always: true },
};

// Tag spellings that mean a catalog skill.
const skillAliases = {
  HTML: "HTML5",
  "HTML/JS": "HTML5",
  "ES6+": "JavaScript",
  WebSocket: "WebSockets",
  "Socket.io": "WebSockets",
  Kafka: "Apache Kafka",
  Shell: "Shell Scripting",
  Bash: "Shell Scripting",
  awk: "Shell Scripting",
  jq: "Shell Scripting",
};

// Tags that describe a project or concept rather than a technology.
const nonSkillTags = new Set([
  "AI", "Algorithms", "Async", "BusyBox", "Cargo", "Collections", "Concurrency",
  "Custom Framework", "Data Structures", "Design Patterns", "DOM", "Extension",
  "Filesystem", "Hackathon", "Kaggle", "Monaco", "NASA API", "Non-blocking I/O",
  "OOP", "Ownership", "Serialization", "Sessions", "Simulation", "SPA",
  "Virtual DOM", "Virtual Hosts",
]);

// Groups the skills used across all projects, most used first. A tag missing
// from the catalog lands in "Other" until it is added there.
export function buildSkills(projectList) {
  const counts = {};
  projectList.forEach((project) =>
    new Set(project.tags.map((tag) => skillAliases[tag] ?? tag)).forEach((name) => {
      if (!nonSkillTags.has(name)) counts[name] = (counts[name] || 0) + 1;
    })
  );
  Object.entries(skillCatalog).forEach(([name, skill]) => {
    if (skill.always && !counts[name]) counts[name] = 0;
  });

  const groups = {};
  Object.entries(counts).forEach(([name, count]) => {
    const { group = "Other", color = "#64748b" } = skillCatalog[name] ?? {};
    (groups[group] ??= []).push({ name, color, count });
  });
  return skillGroups
    .filter((group) => groups[group])
    .map((group) => [
      group,
      groups[group].sort((a, b) => b.count - a.count || a.name.localeCompare(b.name)),
    ]);
}

export const skillsData = buildSkills(projects);
